import { render, staticRenderFns } from "./BaseBoxTitleMoudle.vue?vue&type=template&id=587a7bbf&scoped=true&"
import script from "./BaseBoxTitleMoudle.vue?vue&type=script&lang=js&"
export * from "./BaseBoxTitleMoudle.vue?vue&type=script&lang=js&"
import style0 from "./BaseBoxTitleMoudle.vue?vue&type=style&index=0&id=587a7bbf&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/_vue-loader@15.10.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "587a7bbf",
  null
  
)

export default component.exports